export const PATH_RUNNER_MODES = {
	SelfLink: 'SelfLink',
	Path: 'Path',
};
